const routes = [
    {
        path: "/prep/holiday",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "prepholiday_index"
        }
    }
]

export default routes;
